export default {
  Choose: 'Chọn/ Bỏ chọn tất cả',
  Display: 'Hiển thị',
  NoData: 'Không có dữ liệu báo cáo',
};
